import React, { useState, useEffect, useRef } from "react";
import {
  course_demo_image,
  marketplace_Course_image,
} from "../../assets/images/images";
import { Link, useNavigate } from "react-router";
import BackButton from "../BackButton/BackButton";
import MarketPlaceCourseCard from "../MarketPlaceCourse/MarketPlaceCourseCard";
import "./MarketPlaceShoppingCart.css";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../features/auth/AuthContext";
import {
  addCourseToCart,
  resetAddToCart,
} from "../../state/actions/addtoCartAction";

import { cartList, resetCartList } from "../../state/actions/cartlistAction";
import MarketplacePriceChekoutList from "./MarketplacePriceChekoutList";
import CancelPopup from "../CancelPopup/CancelPopup";
import {
  removeCartData,
  resetRemoveCart,
} from "../../state/actions/removeCartAction";
import {
  getSuggestedCourses,
  resetSuggestedCoursesList,
} from "../../state/actions/cartSuggestedCoursesAction";
import { toast } from "react-toastify";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from "react-responsive-modal";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { emptyCartImage } from "../../assets/images/images";
import CartImg from "./CartImg";
import StudentSuggesionCourseData from "../../pages/home/components/dashboard/student/course/StudentSuggesionCourseData";
import LoaderComponent from "../LoaderComponent/LoaderComponent";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";
import Loader from "../FileRepo/Components/Loader";

function MarketPlaceShoppingCart() {
  const [openDialog, setOpenDialog] = useState(false);
  const [item_id, setitem_id] = useState();
  const [deletingIds, setDeletingIds] = useState(new Set());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartlistData = useSelector((state) => state.cartlist);
  const removeCart = useSelector((state) => state.removeCartData);
  const { suggestedCourses, isLoading } = useSelector(
    (state) => state.suggestedCourses,
  );
  const { token } = useAuth();
  const addToCartState = useSelector((state) => state.addToCart);

  const [loading, setLoading] = useState(false);
  const currency_symbol = useSelector(
    (state) => state?.globalState?.currency_symbol,
  );
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  //bb
  const [cartItems, setCartItems] = useState([]);
  const [bandi, setBandi] = useState(true);

  const deleteTimersRef = useRef({});
  const countdownIntervalsRef = useRef({});

  const [pendingDeletes, setPendingDeletes] = useState({});

  const [hiddenIds, setHiddenIds] = useState(new Set());

 const visibleCartItems = (cartlistData?.cartList || []).filter(
  (x) => !hiddenIds.has(x.cart_item_id)
);
const useNow = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  return now;
};

// Inside component:
const now = useNow();



  useEffect(() => {
    if (token) {
      setHiddenIds(new Set());
      setPendingDeletes([]);
      dispatch(cartList(token));
    }
  }, [token, dispatch]);


  useEffect(() => {
    if (addToCartState?.message?.length) {

      dispatch(cartList(token));
    }
  }, [addToCartState, token, dispatch]);


    


const handleDelete = (item) => {
  const id = item.cart_item_id;
  
   setDeletingIds((prev)=>new Set(prev).add(id))
  setTimeout(()=>{
setHiddenIds((prev) => new Set(prev).add(id));
 setDeletingIds((prev)=>{
    const next= new Set(prev);
    next.delete(id);
    return next;
  })
  },400)

  const expiresAt = Date.now() + 5000;

  const timeoutId = setTimeout(() => {
    dispatch(removeCartData({ cart_item_id: id }, token));
    setPendingDeletes((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  }, 5000);

  setPendingDeletes((prev) => ({
    ...prev,
    [id]: { item, timeoutId, expiresAt },
  }));
};



const handleUndo = (id) => {
  const pending = pendingDeletes[id];
  if (!pending) return;

  clearTimeout(pending.timeoutId);
  setDeletingIds((prev)=>{
    const next= new Set(prev);
    next.delete(id);
    return next;
  })
  setHiddenIds((prev) => {
    const next = new Set(prev);
    next.delete(id);
    return next;
  });

  setPendingDeletes((prev) => {
    const updated = { ...prev };
    delete updated[id];
    return updated;
  });
};


  const handleNavigateAway = () => {
    localStorage.setItem("studentHomeScrollPosition", window.pageYOffset);
  };


  useEffect(() => {
    if (removeCart?.message?.length) {
      toast.success(removeCart?.message);
     
      // Refresh cart list after successful deletion
      dispatch(cartList(token));
    }
    if (removeCart?.error?.length) {
      toast.error(removeCart?.error);
     
    }
    return () => {
      dispatch(resetRemoveCart());
    };
  }, [removeCart]);

  useEffect(() => {
    dispatch(getSuggestedCourses(token));
    return () => {
      dispatch(resetSuggestedCoursesList());
    };
  }, [addToCartState]);

  useEffect(() => {
    if (addToCartState?.message?.length) {
      console.log(addToCartState?.message);

      //toast.success(addToCartData?.message);
    }
    if (addToCartState?.error?.length) {
      console.log(addToCartState?.error);

      // toast.error(addToCartData?.error);
    }
    return () => {
      dispatch(resetAddToCart());
    };
  }, [addToCartState, dispatch]);


  const show = () => {
    setOpenDialog(false);
 
    const req = {
      cart_item_id: item_id,
    };
    dispatch(removeCartData(req, token));
  };

  const close = (id) => {
    setitem_id(id);
    setOpenDialog(!openDialog);
  };

  const truncateByWords = (text, wordLimit = 80) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);

    if (words.length <= wordLimit) {
      return text;
    }

    return words.slice(0, wordLimit).join(" ") + "...";
  };
  useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.hidden) {
      Object.entries(pendingDeletes).forEach(([id, { timeoutId, item }]) => {
        clearTimeout(timeoutId);
        dispatch(removeCartData({ cart_item_id: id }, token));
      });
      setPendingDeletes({});
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);
  return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
}, [pendingDeletes, token, dispatch]);
  return (
    <>
  {cartlistData.isLoading ? <Loader/>
    : (<div className="marketplace-shopping-cart-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="view-course-Details-back-btn-folder"
                onClick={() => {
                  navigate("/dashboard/home");
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
                Back
              </div>

              <div className="marketplace-shopping-cart-main-container">
                {/* Row 1: Cart Items + Checkout Summary */}
                <div className="marketplace-shopping-cart-top-row">
                  {
                    // cartItems.length === 0 ? (
                    // cartItems.length === 0 && !pendingDelete ? (
                    // visibleCartItems.length === 0 && !pendingDelete ? (
                    visibleCartItems.length === 0 && Object.keys(pendingDeletes).length === 0 ? (
                      <div className="empty-cart">
                        {/* <img src={emptyCartImage} alt="Empty Cart" /> */}
                        <CartImg />
                        <h2>Your cart is empty.</h2>
                        <p>Keep shopping to find your courses!</p>
                        <button
                          onClick={() => navigate("/dashboard/market-place")}
                        >
                          Keep Shopping
                        </button>
                      </div>
                    ) : (
                      <>
                        {/* Left: Cart Items */}
                        <div className="marketplace-shopping-cart-left-section-wrapper">
                          <div
                            className="shopping-cart-header"
                            // style={{ position: "relative" }}
                          >
                            <h1 className="shopping-cart-header-title">
                              Shopping Cart
                            </h1>
                            {visibleCartItems.length > 0 && (
                              <h1
                                style={{ marginRight:"1.2rem" }}
                              >
                                Price
                              </h1>
                            )}
                          </div>{" "}
                          {/* <p>
                            {cartlistData?.cartList?.length} Course(s) in cart
                          </p>    */}
                          <p>
  {cartlistData?.cartList?.length} Course{cartlistData?.cartList?.length !== 1 ? "s" : ""} in cart
</p>
                          <div className="marketplace-shopping-cart-left-container">
                            {/* {pendingDeletes && (
                                                            <div className="undo-bar">
                                                                <div className="undo-text">
                                                                    <span
                                                                        className="undo-link"
                                                                    // onClick={() =>
                                                                    //     navigate(`/course/${pendingDelete.item.course_id}/view`, {
                                                                    //         state: { redirectTo: "cart" }
                                                                    //     })
                                                                    // }
                                                                    >
                                                                        {pendingDelete.item.name}
                                                                    </span>
                                                                    <span className="undo-message">
                                                                        &nbsp;was removed from Shopping Cart.
                                                                    </span>
                                                                </div>

                                                                <button className="undo-btn" onClick={handleUndo}>
                                                                    Undo ({Countdown})
                                                                </button>
                                                            </div>
                                                        )} */}

                            <div className="undo-bar-sticky-wrapper">
                              {Object.values(pendingDeletes).map(
                                ({ item, expiresAt }) => {
                                  const remaining = expiresAt - now;
                                  const countdown =
                                    remaining <= 0
                                      ? 0
                                      : Math.ceil(remaining / 1000) - 1;
                                  return (
                                    <div
                                      className="undo-bar"
                                      key={item.cart_item_id}
                                    >
                                      <div className="undo-text">
                                        <span className="undo-link">
                                          {item.name}{" "}
                                        </span>
                                        <span className="undo-message">
                                          {"  "}
                                            was removed from Shopping Cart.
                                        </span>
                                      </div>
                                      <button
                                        className="undo-btn"
                                        onClick={() =>
                                          handleUndo(item.cart_item_id)
                                        }
                                      >
                                        Undo ({countdown})
                                      </button>
                                    </div>
                                  );
                                },
                              )}
                            </div>

                            {visibleCartItems.map((items, index) => (
                              <div
                                //  onClick={() =>
                                //           navigate(
                                //             `/course/${items.course_id}/view`,
                                //             {
                                //               state: {
                                //                 redirectTo: "cart",
                                //                 course: { ...items, in_cart: true },
                                //               },
                                //             },
                                //           )
                                //         }
                                onClick={() => {
                                  const url = `/course/${items.course_id}/view?from=cart`;
                                  window.open(
                                    url,
                                    "_blank",
                                    "noopener,noreferrer",
                                  );
                                }}
                                className={`marketplace-shopping-cart-left-section ${
                                  deletingIds?.has(items?.cart_item_id)
                                    ? "slide-out"
                                    : ""
                                }`}
                                style={{ cursor: "pointer" }}
                                key={items?.cart_item_id || index}
                              >
                                <div className="view-course-details-image course-bg-image">
                                  <img src={items?.image_url} alt="" />
                                </div>
                                <div className="marketplace-shopping-cart-des-wrapper">
                                  <span
                                    className="delete"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDelete(items, index);
                                    }}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </span>
                                  <p className="course-name">
                                    {items?.subject}
                                  </p>
                                  {/* <div className="studentDashboar-Suggested-Courses-profile-rate">
                                                            <a href="#"><i className="fa-solid fa-star"></i></a>
                                                            <p className="rate">4.1</p>
                                                            <p className="number">(322) View Ratings</p>
                                                        </div> */}
                                  <div className="bandi">
                                    <div className="flex gap-2">
                                      <h2 className="leading-[35px]"  data-tooltip-id="course-name"
                                          data-tooltip-content={items?.name}>{items?.name?.length > 60
                                            ? `${items.name.substring(0, 60)}...`
                                            : items?.name}</h2>
                                      <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                                        <a>
                                          <i className="fa-solid fa-star"></i>
                                        </a>
                                        <p className="rate">
                                          {items?.average_course_rating || "0"}
                                        </p>
                                        <p className="number">
                                          ({parseInt(items?.rating_count || 0)})
                                        </p>     
                                      </div>
                                    </div>
                                    <div className="marketplace-shopping-cart-price-wrapper">
                                      <div className="marketplace-shopping-cart-price-discount">
                                        {/* {items.discounted_price ? (
                                        <h2 className="marketplace-shopping-cart-price">
                                          {currency_symbol ?? ""}
                                          {items?.discounted_price}
                                        </h2>
                                      ) : (
                                        <h2 className="marketplace-shopping-cart-price">
                                          {currency_symbol ?? ""}
                                          {items?.price} 
                                        </h2>
                                      )} */}
                                        {items?.price == null ? (
                                          <span
                                            style={{
                                              display: "inline-block",
                                              backgroundColor: "#EEF4FF",
                                              color: "#0068FF",
                                              fontSize: "13px",
                                              fontWeight: 500,
                                              padding: "6px 16px",
                                              borderRadius: "999px",
                                              lineHeight: "1",
                                              whiteSpace: "nowrap",
                                              textDecoration: "none",
                                            }}
                                          >
                                            Free Course
                                          </span>
                                        ) : items?.discounted_price != null ? (
                                          <h2 className="marketplace-shopping-cart-price">
                                            {currency_symbol ?? ""}
                                            {items?.discounted_price}
                                          </h2>
                                        ) : (
                                          <h2 className="marketplace-shopping-cart-price">
                                            {currency_symbol ?? ""}
                                            {items?.price}
                                          </h2>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="studentDashboar-profile-image-bb">
                                    <img
                                      src={items?.ai_avatar}
                                      alt="Teacher Avatar"
                                    />
                                    <p
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(
                                          `/Teacher/${items?.teacher_id}`,
                                        );
                                      }}
                                      className="teacher-name"
                                    >
                                      {items?.teacher_name}
                                    </p>
                                  </div>

                                  {/* <p>
                                    {" "}
                                    {truncateByWords(items?.description, 15)}
                                  </p> */}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Right: Checkout Summary */}
                        <div className="marketplace-shopping-cart-right-section">
                          <MarketplacePriceChekoutList
                            disabled={Object.keys(pendingDeletes).length > 0}
                            close={close}
                          />
                        </div>
                      </>
                    )
                  }
                </div>

                {/* Row 2: Suggested Courses */}
                <div className="marketplace-suggested-courses-section">
                  <h2 className="title">You might also like</h2>
                  {isLoading && <LoadingComponent />}
                  <div className="ratingCard-wrapper">
                    {suggestedCourses.length > 0 &&
                      // suggestedCourses.map((sugg_courses) => {
                      //     return <MarketPlaceCourseCard
                      //         key={sugg_courses?.course_id}
                      //         course_demo_image={sugg_courses?.image_url}
                      //         title={sugg_courses?.teacher_name}
                      //         rate={sugg_courses?.average_rating}
                      //         number={sugg_courses?.ratings_count}
                      //         Course_name={sugg_courses?.subject}
                      //         course_title={sugg_courses?.name}
                      //         discounted_price={sugg_courses?.discounted_price}
                      //         price={sugg_courses?.price}
                      //         ai_avatar={sugg_courses?.ai_avatar}
                      //         button_name1="View Course"
                      //         button_name2="Add to Cart"
                      //         course_id={sugg_courses?.course_id}
                      //         course={sugg_courses}
                      //         onNavigateAway={handleNavigateAway}
                      //     />
                      // })
                      suggestedCourses.map((course, index) => (
                        <StudentSuggesionCourseData
                          onNavigateAway={handleNavigateAway}
                          key={index}
                          course={course}
                        />
                      ))}
                  </div>
                  {!isLoading && suggestedCourses.length === 0 && (
                    <div className="empty-suggested-courses">
                      <p>No Courses Found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>)}
      {/* ) } */}
      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </>
  );
}

export default MarketPlaceShoppingCart;